import { NgZone } from '@angular/core';
import { AppComponent } from './app.component';
export class Interface {
    app: AppComponent;
    constructor(private _ngZone: NgZone, app: AppComponent) {
        this.app = app;
        window['angularUnityInterface'] = {
            zone: this._ngZone, 
            onHome: () => this.onHome(),  
            onTransferStart: () => this.onTransferStart(),
            onTransferEnd: (d) => this.onTransferEnd(d),
            onShowVideo: (d) => this.onShowVideo(d),
            onSetLocation: (d) => this.onSetLocation(d),
            component: this
        };
    }
    onHome() {
        this.app.currentLocation = "Home";
    }
    onTransferStart() {
        this.app.onTransferStart();
    }
    onSetLocation(newLocation: string) {
        this.app.onSetLocation(newLocation);
    }
    onTransferEnd(newLocation: string) {
        this.app.onTransferEnd(newLocation);
    }

    onShowVideo(video: string) {
        console.log("START VIDEO: ",video);
        this.app.onShowVideo(video);
    }
}



// WEBPACK FOOTER //
// ./src/app/interface.ts